import { render, staticRenderFns } from "./ValFormInput.vue?vue&type=template&id=2b1e18d4&"
import script from "./ValFormInput.vue?vue&type=script&lang=ts&"
export * from "./ValFormInput.vue?vue&type=script&lang=ts&"
import style0 from "./ValFormInput.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports